import { useRef, useState, useEffect, EffectCallback } from "react";

const useEffectOnce = (effect: EffectCallback) => {
  const destroyFunc = useRef<void | (() => void)>();
  const effectCalled = useRef(false);
  const renderAfterCalled = useRef(false);
  const [, setVal] = useState<number>(0);
  if (effectCalled.current) {
    renderAfterCalled.current = true;
  }
  useEffect(() => {
    if (!effectCalled.current) {
      destroyFunc.current = effect();
      effectCalled.current = true;
    }
    setVal((val) => val + 1);
    return () => {
      if (!renderAfterCalled.current) {
        return;
      }
      if (destroyFunc.current) {
        destroyFunc.current();
      }
    };
  }, []);
};

const useConditionalEffectOnce = (effect: EffectCallback, condition: boolean): void => {
  const destroyFunc = useRef<void | (() => void)>();
  const effectCalled = useRef(false);
  const renderAfterCalled = useRef(false);
  const [, setVal] = useState<number>(0);
  if (effectCalled.current) {
    renderAfterCalled.current = true;
  }
  useEffect(() => {
    if (!effectCalled.current && condition) {
      destroyFunc.current = effect();
      effectCalled.current = true;
    }
    setVal((val) => val + 1);
    return () => {
      if (!renderAfterCalled.current) {
        return;
      }
      if (destroyFunc.current) {
        destroyFunc.current();
      }
    };
  }, [condition]);
};

export { useEffectOnce, useConditionalEffectOnce };
